import {
  Avatar,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { allJugadoresAction } from '../JugadoresAction';

const SelectFieldJugadoresComponent = ({
  onChange,
  value = '',
  data,
  selects = [],
  isAutoComplete,
  label,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const jugadoresStore = Redux.useSelector((state) => state.jugadores);

  const [jugadores, setJugadores] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      jugadoresStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setJugadores(items);
    } else {
      if (data) {
        setJugadores(data);
      } else {
        setJugadores(jugadoresStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && jugadoresStore.all && jugadoresStore.all.length === 0) {
        await allJugadoresAction(dispatch, entidadesStore.activo.id, null);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.jugador.name}`}>
        {label ?? CONST.jugador.label}
      </InputLabel>
      <Select
        id={CONST.jugador.name}
        value={value?.toString()}
        labelId={`label_${CONST.jugador.name}`}
        label={label ?? CONST.jugador.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {jugadores.map((el, index) => {
          return (
            <MenuItem key={`jugador-${index}`} value={el.id}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar
                  alt={el.jugador.perfil.avatar}
                  sx={{ width: 30, height: 30 }}
                  src={getFilesArchivos(el.jugador.perfil.avatar)}
                />
                <Typography
                  variant="body1"
                  color="initial"
                  sx={{ fontWeight: 'bold' }}
                >
                  {el.jugador.perfil.pnombre} {el.jugador.perfil.papellido}
                </Typography>
              </Stack>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-jugadores"
      opt={jugadores}
      type={CONST.jugador.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l="Jugadores"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldJugadoresComponent;
